import { render, staticRenderFns } from "./RechazarCotizacion.vue?vue&type=template&id=71d47e86&scoped=true&lang=pug"
import script from "./RechazarCotizacion.vue?vue&type=script&lang=js"
export * from "./RechazarCotizacion.vue?vue&type=script&lang=js"
import style0 from "./RechazarCotizacion.vue?vue&type=style&index=0&id=71d47e86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d47e86",
  null
  
)

export default component.exports